import React from 'react'

import { Box, Button, Modal } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'

function TeamActivationModal({ toggleTeamActivationModal }) {
  const modalBody = (
    <Box>
      <Text
        fontSize={theme.fontSizes.pLarge16}
        color={theme.colors.textGray}
        mb={3}
      >
        Activate your account to unlock full access to rental applications and
        rental references with your team.
      </Text>

      <Box mb={4}>
        <Text
          fontSize={theme.fontSizes.pSmall12}
          fontWeight={theme.fontWeights.h4}
          color={theme.colors.gray700}
          mb={2}
        >
          WITH ACTIVATION, YOU'LL BE ABLE TO:
        </Text>
        <Text
          fontSize={theme.fontSizes.pDefault}
          color={theme.colors.textGray}
          mb={1}
        >
          • Access past rental references and collaborate with colleagues
        </Text>
        <Text
          fontSize={theme.fontSizes.pDefault}
          color={theme.colors.textGray}
          mb={1}
        >
          • Receive applications from your website and participating portals
        </Text>
        <Text fontSize={theme.fontSizes.pDefault} color={theme.colors.textGray}>
          • Explore the power of the Snug Leasing Solution
        </Text>
      </Box>

      <Box mb={3}>
        <Button
          as="a"
          href="https://help.snug.com/hc/en-us/requests/new?utm_source=snug_app&utm_medium=modal&utm_campaign=activation_popup"
          target="_blank"
          rel="noopener noreferrer"
          variant="solidSuccessStrong"
          sizeVariant="large"
          style={{ textDecoration: 'none', display: 'inline-block' }}
        >
          Get Started Now
        </Button>
      </Box>

      <Text
        fontSize={theme.fontSizes.pSmall12}
        color={theme.colors.gray500}
        mb={-2}
      >
        Any questions? Visit{' '}
        <a
          href="https://snug.com/help?utm_source=snug_app&utm_medium=modal&utm_campaign=activation_popup"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: theme.colors.skyBlue, textDecoration: 'none' }}
        >
          snug.com/help
        </a>{' '}
        to contact our support team.
      </Text>
    </Box>
  )
  return (
    <Modal
      toggleModal={toggleTeamActivationModal}
      modalHeading="Ready to Activate Your Account? 🚀"
      modalBody={modalBody}
      showPrimaryButton={false}
      showSecondaryButton={false}
    />
  )
}

export default TeamActivationModal
